import { useEffect, useState } from "react";
import vietQrApi from "../../../api/vietQrApi";
import gameApi from "../../../api/gameApi";

function UpdatePaidCoin({ onClose, paidInfo, reloadPaidCoins }) {
    const [bill, setBill] = useState();
    const [qrUrl, setQrUrl] = useState("");

    const onPaste = (e) => {
        const file = e.clipboardData.files[0];
        setBill(file);
    };

    const PAYMENT_NOTE = `longhousee trao thuong userid ${paidInfo?.user.username || ""}`;

    let billUrl;
    if (bill) {
        billUrl = URL.createObjectURL(bill);
    }

    const onSumbit = async () => {
        if (!paidInfo || !bill) return;
        const formData = new FormData();
        formData.append("userId", paidInfo.user.userId);
        formData.append("image", bill);
        formData.append("id", paidInfo.id);
        try {
            await gameApi.changePendingToSuccessCoid(formData);
            await reloadPaidCoins();
            onCancel();
        } catch (error) {
            console.log(error);
        }
    };

    const onCancel = () => {
        setQrUrl();
        onClose();
        setBill();
    };

    useEffect(() => {
        if (!paidInfo || !paidInfo?.user?.bankInfo) return;
        const fetchQR = async () => {
            if (paidInfo.user?.bankInfo?.bin) {
                try {
                    const { data } = await vietQrApi.generateQr(
                        paidInfo.user.accountNumber,
                        paidInfo.user.accountName,
                        paidInfo.user.bankInfo.bin,
                        paidInfo.coin,
                        paidInfo.user.username,
                        `${PAYMENT_NOTE}`
                    );
                    setQrUrl(data.data.qrDataURL);
                } catch (error) {
                    console.log(error);
                }
            }
        };
        fetchQR();
    }, [paidInfo, PAYMENT_NOTE]);
    return (
        <div className="w-full flex justify-center items-center h-[580px]">
            {qrUrl && (
                <div className="h-full bg-surface">
                    <div className="h-2/3">
                        <img src={qrUrl} alt="qr" className="h-full object-cover" />
                    </div>
                </div>
            )}
            <div className="w-[480px] bg-surface p-4 h-full flex flex-col justify-between">
                <div className="flex flex-col gap-3">
                    <h4>Thông tin chi tiết:</h4>
                    {paidInfo && (
                        <div className="flex flex-col gap-2">
                            <div className="flex justify-between">
                                <span>userId:</span>
                                <span>{paidInfo.user.userId}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>usename:</span>
                                <span>{paidInfo.user.username}</span>
                            </div>
                            {paidInfo.user.bankInfo && (
                                <>
                                    <div className="flex justify-between">
                                        <span>Ngân hàng:</span>
                                        <span>{paidInfo.user.bankInfo.bankName.split("-")[0]}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>Chủ tài khoản:</span>
                                        <span>{paidInfo.user.accountName}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>Số tài khoản:</span>
                                        <span>{paidInfo.user.accountNumber}</span>
                                    </div>
                                </>
                            )}
                            {!paidInfo.user?.bankInfo && (
                                <div className="flex justify-between">
                                    <span>Hình thức thanh toán:</span>
                                    <span className="text-orange-500">Shopee Pay</span>
                                </div>
                            )}
                            <div className="flex justify-between">
                                <span>số tiền:</span>
                                <span>{parseFloat(paidInfo.coin).toLocaleString("vi-VN")}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Nội dung:</span>
                                <span className="text-end">{PAYMENT_NOTE}</span>
                            </div>
                        </div>
                    )}
                    <div>
                        <input className="p-3 bg-surface-raised w-full rounded-md" type="text" placeholder="paste Bill" onPaste={onPaste} />
                    </div>
                </div>
                <div className="flex justify-between gap-3">
                    <button onClick={onSumbit} className="w-full p-3 border rounded-md">
                        Xác nhận
                    </button>
                    <button onClick={onCancel} className="w-full p-3 bg-pink-600 text-white rounded-md">
                        Huỷ
                    </button>
                </div>
            </div>
            {bill && (
                <div className="h-full">
                    <img src={billUrl} alt="bill" className="h-full object-contain w-80" />
                </div>
            )}
        </div>
    );
}

export default UpdatePaidCoin;
